import { useQuery } from '@apollo/client'

import {
  Portfolio,
  PortfolioQuery,
  PortfolioQueryVariables,
} from '@/clients/utoniq-core/schema'
import { useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'
import { useDeviceInfo } from '@/core/native/device'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { loading: deviceInfoLoading, deviceInfo } = useDeviceInfo()
  const { router } = useRouter<{ itemId: string }>()
  const { data: portfolioData, loading } = useQuery<
    PortfolioQuery,
    PortfolioQueryVariables
  >(Portfolio, {
    variables: {
      id: router.query.itemId,
      platform: deviceInfo?.platform ?? '',
    },
    skip: deviceInfoLoading,
  })

  return {
    state: {
      loading,
      item: (portfolioData?.portfolio?.item as never) ?? null,
      serials: portfolioData?.portfolio?.serials ?? null,
    },
    actions: {},
  }
})
